module.exports = __webpack_public_path__ + "img/11_91.ecfaa42a.png";